export default __webpack_public_path__ + "static/media/BG-ProgramConfirmationPage.8009ad99.svg";